"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAchievementEvent = exports.AchievementEventSchema = exports.isUserWithoutLanguageLearnerAchievementEvent = exports.isResetLanguageDataAchievementEvent = exports.AchievementEventNameSchema = void 0;
const zod_1 = require("zod");
const language_codes_types_1 = require("../language_codes_types");
exports.AchievementEventNameSchema = zod_1.z.union([
    zod_1.z.literal("FirstLanguageSelected"),
    zod_1.z.literal("CompletedLearnHowToDoReviews"),
    zod_1.z.literal("CompletedVocabSet"),
    zod_1.z.literal("CompletedReview"),
    zod_1.z.literal("CompletedGuidedLearningChapter"),
    zod_1.z.literal("CompletedGuidedLearningWeek"),
    zod_1.z.literal("CompletedGuidedLearning"),
    zod_1.z.literal("ResetLanguageData"),
    zod_1.z.literal("UserWithoutLanguageLearnerAchievement"),
    zod_1.z.literal("MinimalPairOnbaordingAnswered"),
    zod_1.z.literal("CompletedPronunciationLesson"),
    zod_1.z.literal("ReadFlashtip"),
    zod_1.z.literal("CreatedWordFlashcards"),
    zod_1.z.literal("MarkedWordAsSkipped"),
    zod_1.z.literal("MarkedWordAsKnown"),
    zod_1.z.literal("PersonalImageUploaded"),
    zod_1.z.literal("SeeTranslation"),
    zod_1.z.literal("FlashcardDeleted"),
    zod_1.z.literal("ReviewImageUpdated"),
    zod_1.z.literal("AdvancedImageSearch"),
    zod_1.z.literal("UndoReviewAnswer"),
]);
const AchievementEventCommonSchema = zod_1.z.object({
    languagePairCode: language_codes_types_1.LanguagePairCodeSchema.optional(),
    userId: zod_1.z.string(),
});
const FirstLanguageSelectedAchievementEventSchema = AchievementEventCommonSchema.extend({
    eventName: zod_1.z.literal("FirstLanguageSelected"),
});
const CompletedLearnHowToDoReviewsAchievementEventSchema = AchievementEventCommonSchema.extend({
    eventName: zod_1.z.literal("CompletedLearnHowToDoReviews"),
});
const CompletedVocabSetAchievementEventSchema = AchievementEventCommonSchema.extend({
    eventName: zod_1.z.literal("CompletedVocabSet"),
    set: zod_1.z.number(),
});
const CompletedtReviewAchievementEventSchema = AchievementEventCommonSchema.extend({
    eventName: zod_1.z.literal("CompletedReview"),
    languagePairCode: language_codes_types_1.LanguagePairCodeSchema,
    percentageOfCorrectFlashcards: zod_1.z.number(),
});
const CompletedGuidedLearningChapterAchievementEventSchema = AchievementEventCommonSchema.extend({
    chapter: zod_1.z.number(),
    eventName: zod_1.z.literal("CompletedGuidedLearningChapter"),
});
const CompletedGuidedLearningWeekAchievementEventSchema = AchievementEventCommonSchema.extend({
    eventName: zod_1.z.literal("CompletedGuidedLearningWeek"),
    week: zod_1.z.number(),
});
const CompletedGuidedLearningAchievementEventSchema = AchievementEventCommonSchema.extend({
    eventName: zod_1.z.literal("CompletedGuidedLearning"),
});
const ResetLanguageDataAchievementEventSchema = AchievementEventCommonSchema.extend({
    eventName: zod_1.z.literal("ResetLanguageData"),
    languagePairCode: language_codes_types_1.LanguagePairCodeSchema,
});
const isResetLanguageDataAchievementEvent = (v) => ResetLanguageDataAchievementEventSchema.safeParse(v).success;
exports.isResetLanguageDataAchievementEvent = isResetLanguageDataAchievementEvent;
const UserWithoutLanguageLearnerAchievementEventSchema = AchievementEventCommonSchema.extend({
    eventName: zod_1.z.literal("UserWithoutLanguageLearnerAchievement"),
});
const isUserWithoutLanguageLearnerAchievementEvent = (v) => UserWithoutLanguageLearnerAchievementEventSchema.safeParse(v).success;
exports.isUserWithoutLanguageLearnerAchievementEvent = isUserWithoutLanguageLearnerAchievementEvent;
const MinimalPairOnboardingAnsweredAchievementEventSchema = AchievementEventCommonSchema.extend({
    eventName: zod_1.z.literal("MinimalPairOnbaordingAnswered"),
});
const CompletedPronunciationLessonAchievementEventSchema = AchievementEventCommonSchema.extend({
    eventName: zod_1.z.literal("CompletedPronunciationLesson"),
});
const ReadFlashtipAchievementEventSchema = AchievementEventCommonSchema.extend({
    eventName: zod_1.z.literal("ReadFlashtip"),
});
const CreatedWordFlashcardsAchievementEventSchema = AchievementEventCommonSchema.extend({
    eventName: zod_1.z.literal("CreatedWordFlashcards"),
});
const MarkedWordAsSkippedAchievementEventSchema = AchievementEventCommonSchema.extend({
    eventName: zod_1.z.literal("MarkedWordAsSkipped"),
});
const MarkedWordAsKnownAchievementEventSchema = AchievementEventCommonSchema.extend({
    eventName: zod_1.z.literal("MarkedWordAsKnown"),
});
const PersonalImageUploadedAchievementEventSchema = AchievementEventCommonSchema.extend({
    eventName: zod_1.z.literal("PersonalImageUploaded"),
    source: zod_1.z.string(),
});
const SeeTranslationAchievementEventSchema = AchievementEventCommonSchema.extend({
    eventName: zod_1.z.literal("SeeTranslation"),
});
const FlashcardDeletedAchievementEventSchema = AchievementEventCommonSchema.extend({
    eventName: zod_1.z.literal("FlashcardDeleted"),
});
const ReviewImageUpdatedAchievementEventSchema = AchievementEventCommonSchema.extend({
    eventName: zod_1.z.literal("ReviewImageUpdated"),
});
const AdvancedImageSearchAchievementEventSchema = AchievementEventCommonSchema.extend({
    eventName: zod_1.z.literal("AdvancedImageSearch"),
});
const UndoReviewAnswerAchievementEventSchema = AchievementEventCommonSchema.extend({
    eventName: zod_1.z.literal("UndoReviewAnswer"),
});
exports.AchievementEventSchema = zod_1.z.union([
    FirstLanguageSelectedAchievementEventSchema,
    CompletedLearnHowToDoReviewsAchievementEventSchema,
    CompletedVocabSetAchievementEventSchema,
    CompletedtReviewAchievementEventSchema,
    CompletedGuidedLearningChapterAchievementEventSchema,
    CompletedGuidedLearningWeekAchievementEventSchema,
    CompletedGuidedLearningAchievementEventSchema,
    ResetLanguageDataAchievementEventSchema,
    UserWithoutLanguageLearnerAchievementEventSchema,
    MinimalPairOnboardingAnsweredAchievementEventSchema,
    CompletedPronunciationLessonAchievementEventSchema,
    ReadFlashtipAchievementEventSchema,
    CreatedWordFlashcardsAchievementEventSchema,
    MarkedWordAsSkippedAchievementEventSchema,
    MarkedWordAsKnownAchievementEventSchema,
    PersonalImageUploadedAchievementEventSchema,
    SeeTranslationAchievementEventSchema,
    FlashcardDeletedAchievementEventSchema,
    ReviewImageUpdatedAchievementEventSchema,
    AdvancedImageSearchAchievementEventSchema,
    UndoReviewAnswerAchievementEventSchema,
]);
const isAchievementEvent = (v) => exports.AchievementEventSchema.safeParse(v).success;
exports.isAchievementEvent = isAchievementEvent;
//# sourceMappingURL=achievements_domain_events_types.js.map